import React from 'react';
import {reduxForm,} from 'redux-form';
import {Alert, Button, Spinner} from 'react-bootstrap';
import {withRouter} from 'react-router';

import {Show} from 'Layout';
import {PageStatus, ProfilesIds} from 'enums';
import GridContainer from "../Grid/GridContainer";
import CardHeader from "../Card/CardHeader";
import {ProfileManagementAPI} from "../../API/ProfileManagementAPI";
import Questions from "./Questions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import Language from "../../Languages/Login/content.json";
import countryConfig from 'config/countryConfig';
import Swal from 'sweetalert2';

export type FormValue = {
    "name": string,
};

type State = {
    status: string,
    error: string | null,
    country: any,
    name: string,
};

class Smokers extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            data: null,
            userResponse: {},
            ma: [],
            pageContent: this.props.language === 'jp' ? Language.profilesJapanese : this.props.language === 'hi' ? Language.profilesHindi : Language.profilesEnglish,
        };
    }

    componentDidMount() {
        if(this.props.userId) {
            this.fetchSmokersDetails();
        }
    }


    componentDidUpdate(prevSmokerProps) {
        if (prevSmokerProps.language !== this.props.language) {
            this.setState({
                pageContent: this.props.language === 'jp' ? Language.profilesJapanese : this.props.language === 'hi' ? Language.profilesHindi : Language.profilesEnglish,
            })
        }
    }

    fetchSmokersDetails() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => ProfileManagementAPI.getOneDetails(ProfilesIds.Smokers, this.props.userId))
            .then((data) => {
                this.initializeSmokersValues(data)
                this.setState({
                    data,
                    status: PageStatus.Loaded,
                }, () => {
                    this.fetchSmokersMA()
                });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    fetchSmokersMA() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => ProfileManagementAPI.getAllMAOptions())
            .then((data) => {
                this.setState({
                    ma: data,
                    status: PageStatus.Loaded,
                });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    smokersFormValues() {
        return {
            userId: this.props.userId,
            profileId: ProfilesIds.Smokers,
            response: this.state.userResponse,
        };
    }

    initializeSmokersValues(data) {
        let response = {};
        if (data.response && Object.keys(data.response).length > 0) {
            const raw = data.response.response;
            if (typeof raw === 'string') {
                try { response = JSON.parse(raw); } catch (e) { response = {}; }
            } else if (raw && typeof raw === 'object') {
                response = raw;
            }
        }
        return this.setState({
            profileId: ProfilesIds.Smokers,
            userResponse: response,
        });
    }

    create() {
        const valuesIn = this.smokersFormValues()
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Submitting }))
            .then(() => ProfileManagementAPI.createUserProfile(valuesIn))
            .then((country) => {
                this.setState({ status: PageStatus.Submitted });
                Swal.fire({ icon: 'success', title: this.props.language === 'jp' ? '詳細を更新しました' : this.props.language === 'hi' ? 'Details Successfully Updated' : 'Details Successfully Updated', timer: 2000, showConfirmButton: false })
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
                Swal.fire({ icon: 'error', title: this.props.language === 'jp' ? '問題が発生しました' : this.props.language === 'hi' ? 'Something Went Wrong' : 'Something Went Wrong' })
            });
    }


    handleSmokersQueRespo = (userResponse) => {
        this.setState({ userResponse })
    };

    calculateSmokersPercentage = () => {
        if(this.state.userResponse) {
            const keysSmokersArray = Object.keys(this.state.userResponse);
            const questionsSomkerTotal = this.state.data ? this.state.data.questions : [];
            if (questionsSomkerTotal.length === 0) return 0;
            const pct = Math.round((keysSmokersArray.length / questionsSomkerTotal.length) * 100);
            return Math.min(pct, 100);
        }
        return 0;
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <GridContainer>
                    <div className='w-100 mb-3'>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>{t('panelistProfile.smokers.heading')}</h4>
                                <div>
                                    <Button
                                        onClick={() => this.create()}
                                        variant="primary"
                                        size="sm"
                                    >
                                        {t('common.saveButton')}
                                    </Button>
                                    <Button
                                        onClick={() => this.props.history.push('/panelist/profile-overview')}
                                        variant="danger"
                                        size="sm"
                                        className="ml-2"
                                    >
                                        {t('common.closeButton')}
                                    </Button>
                                </div>
                            </div>
                        </CardHeader>
                    </div>
                </GridContainer>
                <Show when={this.state.status === PageStatus.Loading}>
                    <div className="d-flex justify-content-center w-100 p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                </Show>

                <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                    {this.state.error}
                </Alert>

                <Show when={this.state.status === PageStatus.Loaded || this.state.status === PageStatus.Submitted}>
                    <div className="jumbotron bg-white p-3 border shadow-sm">
                        <p>
                            {this.state.pageContent.message.title.replace("{brand}", countryConfig.brandName)}
                            <b className='text-primary'> {this.state.pageContent.message.link.replace("{brand}", countryConfig.brandName)}.</b>
                            <h4 className="text-center ng-binding" >{this.calculateSmokersPercentage()}% {this.state.pageContent.profileOverall.title}</h4>
                        </p>
                        <div className="progress">
                            <div className="progress-bar" style={{width: `${this.calculateSmokersPercentage()}%`}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>
                                {this.calculateSmokersPercentage()}%
                            </div>
                        </div>
                    </div>
                    <Questions
                        questions={this.state.data ? this.state.data.questions : []}
                        onHandleQuestionResponse={(data) => this.handleSmokersQueRespo(data)}
                        userResponse={this.state.userResponse}
                        language={this.props.language}
                        ma={this.state.ma}
                    />
                </Show>
            </>
        );
    }
}

const SmokersRedux = reduxForm<FormValue, any>({
    form: 'Smokers',
})(withTranslation()(Smokers));

const mapStateToProps = (state: { adminUser: { adminUser: { language: any, phoneNumber: any, email: any, userId: any; token: any; loading: any; error: any; role: any }; }; }) => {
    return {
        userId: state.adminUser.adminUser.userId,
        role: state.adminUser.adminUser.role,
        phoneNumber: state.adminUser.adminUser.phoneNumber,
        email: state.adminUser.adminUser.email,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
        language: state.adminUser.adminUser.language,
    };
};

const SmokersWithRouter = withRouter(connect(mapStateToProps)(SmokersRedux));

export { SmokersWithRouter as Smokers };
